import { z } from "zod";

export const HorseSchema = z.object({
    name: z.string().min(1, "Horse name is required"),
    dob: z.string().min(1, "DOB is required"),
    discipline: z.array(z.string()).min(1, "Discipline is required"),
    registeredName: z.string().optional().nullable(),
    photo: z.string().optional().nullable(),
});

export const HorseOwnershipSchema = z.object({
    email: z.string().min(1, "Email is required").email("Invalid email address"),
});